import styled from "styled-components";
import { CONTENT_WIDTH, media } from "@/theme/breakpoints";

export const PageRoot = styled.div`
  overflow-x: hidden;
  width: 100%;
  box-sizing: border-box;

  ${media.downTablet`
    padding: 0 24px;
  `}

  ${media.downMobile`
    padding: 0 16px;
  `}
`;

export const ContentWrap = styled.div`
  width: ${CONTENT_WIDTH.pct};
  max-width: 100%;
  margin: 0 auto;
`;
